import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, map } from 'rxjs/operators';
import { ButtonTypeAttributeEnum } from '@hrra/ui';
import { ButtonTypeEnum } from '@hrra/ui';
import {
  activateJobseekerEmailChanges,
  cancelJobseekerEmailChanges,
  updateEmail,
} from 'src/app/root-store/jobseeker-store/jobseeker-settings/actions';
import {
  selectCurrentPasswordIsIncorrect,
  selectIsEmailChangeActive,
  selectIsPasswordChangeActive,
} from 'src/app/root-store/jobseeker-store/jobseeker-settings/selectors';
import { AppState } from 'src/app/root-store/state';
import {
  JobseekerRegistrationValidationMessage,
  JobseekerService,
} from '../shared/services/jobseeker.service';
import { loadJobseekerProfile } from 'src/app/root-store/jobseeker-store/jobseeker-profile/actions';
import { selectUserEmail } from 'src/app/root-store/jobseeker-store/jobseeker-profile/selectors';
import { Patterns } from '@hrra/core';

@Component({
  selector: 'app-jobseeker-settings-change-email',
  templateUrl: './redesign/jobseeker-settings-change-email.component.html',
  styleUrls: ['./redesign/jobseeker-settings-change-email.component.scss'],
  standalone: false,
})
export class JobseekerSettingsChangeEmailComponent
  implements OnInit, OnDestroy
{
  editForm: UntypedFormGroup;

  isCurrentPasswordIncorrect$: Observable<boolean>;

  isPasswordChangeActive$: Observable<boolean>;
  isEmailChangeActive$: Observable<boolean>;

  messagetTypeErrorTextMap: { [index: number]: string };

  userMail$: Observable<string>;

  public buttonType: any;
  public buttonAttributeType: any;

  public passwordMinLength: number;

  constructor(
    private fb: UntypedFormBuilder,
    private store: Store<AppState>,
    private jobseekerService: JobseekerService
  ) {
    this.buttonType = ButtonTypeEnum;
    this.buttonAttributeType = ButtonTypeAttributeEnum;

    this.messagetTypeErrorTextMap = {
      [JobseekerRegistrationValidationMessage.EmailRegisteredButBelongsToCustomer]:
        'text.EmailRegisteredButBelongsToCustomer',
      [JobseekerRegistrationValidationMessage.EmailRegisteredButJobseekerPending]:
        'text.EmailRegisteredToAccessYourAccountPleaseLogin',
      [JobseekerRegistrationValidationMessage.EmailRegisteredToAccessYourAccountPleaseLogin]:
        'text.EmailRegisteredToAccessYourAccountPleaseLogin',
    };

    this.editForm = this.fb.group({
      password: new UntypedFormControl(null, [Validators.required]),
      newEmail: new UntypedFormControl(
        null,
        [Validators.required, Validators.pattern(Patterns.emailNew)],
        this.validateEmail.bind(this)
      ),
    });
  }

  validateEmail({
    value,
  }: AbstractControl): Observable<ValidationErrors | null> {
    return this.jobseekerService.validateEmail(value).pipe(
      debounceTime(500),
      map((d) => {
        if (d.data.isSuccess) {
          return null;
        } else {
          return { server: d.data.items[0].message };
        }
      }),
      catchError(() => of(null))
    );
  }

  getValidationMessage(messageType: JobseekerRegistrationValidationMessage) {
    console.log(messageType)
    return this.messagetTypeErrorTextMap[messageType];
  }

  onChangeEmail(): void {
    this.editForm.reset();
    this.store.dispatch(activateJobseekerEmailChanges());
  }

  ngOnInit(): void {
    this.isCurrentPasswordIncorrect$ = this.store.pipe(
      select(selectCurrentPasswordIsIncorrect)
    );

    this.store.dispatch(loadJobseekerProfile());

    this.isPasswordChangeActive$ = this.store.select(
      selectIsPasswordChangeActive
    );
    this.isEmailChangeActive$ = this.store.select(selectIsEmailChangeActive);

    this.userMail$ = this.store.select(selectUserEmail);
  }

  onCancel() {
    this.editForm.get('password').reset();
    this.editForm.get('newEmail').reset();

    this.store.dispatch(cancelJobseekerEmailChanges());
  }

  onSave() {
    if (this.editForm.valid) {
      const value = this.editForm.value;

      const updateData = {
        newEmail: value.newEmail,
        password: value.password,
      };

      this.store.dispatch(updateEmail({ payload: updateData }));
    }
  }

  ngOnDestroy() {
    this.editForm.get('password').reset();
    this.editForm.get('newEmail').reset();

    this.store.dispatch(cancelJobseekerEmailChanges());
  }
}
